import React, { ReactElement } from 'react';
import {
  Button, FormGroup, Heading, Input, Label, LoaderButton, Textarea,
} from 'idsk-react-components';
import { SafeParameterSetter } from '../../../../types/SafeParameterSetter';
import LegislativnyMaterialCreateUpdate
  from '../../../../model/legislativnyMaterial/LegislativnyMaterialCreateUpdate';
import LegMaterialCreateStepEnum
  from '../../../../model/legislativnyMaterial/LegMaterialCreateStepEnum';
import CheckDataTable from '../component/CheckDataTable';
import MultiSelectWithTreeForOblast from '../../../MultiSelectWithTreeForOblast';
import {
  arrayIncludesInObj,
  basicAttributeKodList,
} from '../../../../function/legMaterialFunctions';

interface Props {
  legislativnyMaterial: LegislativnyMaterialCreateUpdate;
  onUpdateField: SafeParameterSetter<LegislativnyMaterialCreateUpdate>;
  loading: boolean;
  getFieldErrorMessage: (fieldName: string) => string;
  onChangeStep: (nextStep: LegMaterialCreateStepEnum) => Promise<void>;
  isUpdate?: boolean;
}

const BasicDataStepTwo = ({
  onUpdateField,
  legislativnyMaterial,
  loading,
  getFieldErrorMessage,
  onChangeStep,
  isUpdate = false,
}: Props): ReactElement => (
  <div>
    <Heading
      className="page-title"
      size="xl"
    >
      {isUpdate ? 'Úprava základných údajov' : 'Vyplňte základné údaje'}
    </Heading>
    <FormGroup error={!!getFieldErrorMessage('nazov')}>
      <Label htmlFor="nazov">Názov</Label>
      <Textarea
        className="idsk-!-width-three-quarters"
        showRemaining
        rows={4}
        id="nazov"
        type="text"
        maxLength={2200}
        name="nazov"
        value={legislativnyMaterial.nazov}
        onChange={({ target }) => onUpdateField('nazov', target.value)}
        error={getFieldErrorMessage('nazov')}
        autoComplete="off"
        expandHeight
      />
    </FormGroup>
    {(legislativnyMaterial.typ?.kod !== 'AktEU') && (
      <>
        <div className="idsk-!-width-one-half">
          <MultiSelectWithTreeForOblast
            oblastList={legislativnyMaterial.oblastList}
            onUpdateField={onUpdateField}
            getFieldErrorMessage={getFieldErrorMessage}
            hint="Začnite písať a vyberte z ponúkaných možností alebo vyberte zo zoznamu."
            label="Právna oblasť"
            optional={legislativnyMaterial.typ?.kod === 'NelegislativnyVseobecnyMaterial'
              || legislativnyMaterial.typ?.kod === 'PersonalnyNavrhNaRokovanieVlady'}
          />
        </div>
        <FormGroup error={!!getFieldErrorMessage('rezortneCislo')}>
          <Label htmlFor="rezortneCislo">Rezortné číslo</Label>
          <Input
            id="rezortneCislo"
            width="one-half"
            type="text"
            maxLength={255}
            name="rezortneCislo"
            value={legislativnyMaterial.rezortneCislo}
            onChange={({ target }) => onUpdateField('rezortneCislo', target.value)}
            error={getFieldErrorMessage('rezortneCislo')}
            autoComplete="off"
          />
        </FormGroup>
        <FormGroup error={!!getFieldErrorMessage('podnet')}>
          <Label htmlFor="podnet">Podnet</Label>
          <Textarea
            className="idsk-!-width-three-quarters"
            showRemaining
            id="podnet"
            type="text"
            maxLength={2048}
            name="podnet"
            rows={4}
            value={legislativnyMaterial.podnet}
            onChange={({ target }) => onUpdateField('podnet', target.value)}
            error={getFieldErrorMessage('podnet')}
            autoComplete="off"
            expandHeight
          />
        </FormGroup>
      </>
    )}
    <LoaderButton
      className="legislativny-material-create__submit-button"
      loading={loading}
      type="submit"
      size="large"
      disableOutsideClickWhileLoading
      onClick={() => onChangeStep((
        arrayIncludesInObj(basicAttributeKodList, legislativnyMaterial.typ?.kod))
        ? LegMaterialCreateStepEnum.PREDKLADATEL_4 : LegMaterialCreateStepEnum.RELATED_DATA_3)}
    >Pokračovať
    </LoaderButton>
    {isUpdate && (
      <Button
        className="legislativny-material__button"
        type="button"
        disabled={loading}
        buttonStyle="third"
        size="large"
        onClick={() => {
          onChangeStep(LegMaterialCreateStepEnum.CHECK_DATA_5);
        }}
      >
        Prejsť na zhrnutie
      </Button>
    )}
    {!isUpdate && (
    <Button
      className="legislativny-material__button"
      type="button"
      buttonStyle="third"
      size="large"
      disabled={loading}
      onClick={() => {
        onChangeStep(LegMaterialCreateStepEnum.TYP_MATERIALU_1);
      }}
    >
      Späť
    </Button>
    )}
    <Heading size="m">Vaše odpovede</Heading>
    <CheckDataTable
      legislativnyMaterial={legislativnyMaterial}
      onChangeStep={onChangeStep}
      isUpdate={isUpdate}
    />
  </div>
);

export default BasicDataStepTwo;
